/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HomeHealthPractitionerRole } from './HomeHealthPractitionerRole';
import {
    HomeHealthPractitionerRoleFromJSON,
    HomeHealthPractitionerRoleFromJSONTyped,
    HomeHealthPractitionerRoleToJSON,
} from './HomeHealthPractitionerRole';
import type { PecosVerification } from './PecosVerification';
import {
    PecosVerificationFromJSON,
    PecosVerificationFromJSONTyped,
    PecosVerificationToJSON,
} from './PecosVerification';
import type { Practitioner } from './Practitioner';
import {
    PractitionerFromJSON,
    PractitionerFromJSONTyped,
    PractitionerToJSON,
} from './Practitioner';

/**
 *
 * @export
 * @interface HomeHealthPractitionerAssignment
 */
export interface HomeHealthPractitionerAssignment {
    /**
     *
     * @type {string}
     * @memberof HomeHealthPractitionerAssignment
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof HomeHealthPractitionerAssignment
     */
    practitioner_id: string;
    /**
     *
     * @type {Date}
     * @memberof HomeHealthPractitionerAssignment
     */
    updated_at: Date;
    /**
     *
     * @type {HomeHealthPractitionerRole}
     * @memberof HomeHealthPractitionerAssignment
     */
    role: HomeHealthPractitionerRole | null;
    /**
     *
     * @type {string}
     * @memberof HomeHealthPractitionerAssignment
     */
    effective_date?: string | null;
    /**
     *
     * @type {string}
     * @memberof HomeHealthPractitionerAssignment
     */
    source_document?: string | null;
    /**
     *
     * @type {Practitioner}
     * @memberof HomeHealthPractitionerAssignment
     */
    practitioner: Practitioner;
    /**
     *
     * @type {PecosVerification}
     * @memberof HomeHealthPractitionerAssignment
     */
    pecos_verification?: PecosVerification;
    /**
     *
     * @type {string}
     * @memberof HomeHealthPractitionerAssignment
     */
    last_checked_at: string | null;
}

/**
 * Check if a given object implements the HomeHealthPractitionerAssignment interface.
 */
export function instanceOfHomeHealthPractitionerAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "practitioner_id" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "practitioner" in value;
    isInstance = isInstance && "last_checked_at" in value;

    return isInstance;
}

export function HomeHealthPractitionerAssignmentFromJSON(json: any): HomeHealthPractitionerAssignment {
    return HomeHealthPractitionerAssignmentFromJSONTyped(json, false);
}

export function HomeHealthPractitionerAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthPractitionerAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': json['id'],
        'practitioner_id': json['practitioner_id'],
        'updated_at': (new Date(json['updated_at'])),
        'role': HomeHealthPractitionerRoleFromJSON(json['role']),
        'effective_date': !exists(json, 'effective_date') ? undefined : json['effective_date'],
        'source_document': !exists(json, 'source_document') ? undefined : json['source_document'],
        'practitioner': PractitionerFromJSON(json['practitioner']),
        'pecos_verification': !exists(json, 'pecos_verification') ? undefined : PecosVerificationFromJSON(json['pecos_verification']),
        'last_checked_at': json['last_checked_at'],
    };
}

export function HomeHealthPractitionerAssignmentToJSON(value?: HomeHealthPractitionerAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'practitioner_id': value.practitioner_id,
        'updated_at': (value.updated_at.toISOString()),
        'role': HomeHealthPractitionerRoleToJSON(value.role),
        'effective_date': value.effective_date,
        'source_document': value.source_document,
        'practitioner': PractitionerToJSON(value.practitioner),
        'pecos_verification': PecosVerificationToJSON(value.pecos_verification),
        'last_checked_at': value.last_checked_at,
    };
}
